module.exports = __webpack_public_path__ + "img/telus-infos-montagne-summer-banner-fr.jpg";